import { ReactNode } from 'react';

interface CvIconContainerProps {
    children: ReactNode;
}

function CvIconContainer({ children }: CvIconContainerProps) {
    return <div className="size-10">{children}</div>;
}

export default CvIconContainer;
